package com.eladfinish.bible.contest.ui.components.toolbar.configuration.model

import com.eladfinish.bible.contest.ui.components.toolbar.model.ToolbarKind
import kotlinx.collections.immutable.ImmutableList
import kotlinx.collections.immutable.persistentListOf
import kotlinx.collections.immutable.toImmutableList

data class ToolbarConfiguration<TId : Enum<TId>>(
    val kind: ToolbarKind,
    val title: ToolbarHeaderComponentConfig,
    val subtitle: ToolbarHeaderComponentConfig? = null,
    val navigationMode: ToolbarNavigationMode = ToolbarNavigationMode.Unspecified,
    val actions: ImmutableList<ToolbarActionConfig<TId>> = persistentListOf(),
    val showDivider: Boolean = false,
) {

    val navigationButton: ToolbarNavigationButtonConfig?
        get() = (navigationMode as? ToolbarNavigationMode.NavigationButton)?.config

    constructor(
        kind: ToolbarKind,
        title: ToolbarHeaderComponentConfig,
        subtitle: ToolbarHeaderComponentConfig? = null,
        action: ToolbarActionConfig<TId>?,
        navigationMode: ToolbarNavigationMode = ToolbarNavigationMode.Unspecified,
        showDivider: Boolean = false,
    ) : this(
        kind = kind,
        title = title,
        subtitle = subtitle,
        navigationMode = navigationMode,
        actions = action?.let { listOf(it) }.orEmpty().toImmutableList(),
        showDivider = showDivider
    )

    companion object {
        fun <TId : Enum<TId>> empty() =
            ToolbarConfiguration<TId>(
                kind = ToolbarKind.None,
                title = ToolbarHeaderComponentConfig.Text("")
            )
    }
}
